import React,{Component} from 'react'
import centralAPI from '../../CentralAPIHandler/CentralAPIHandler';
import {hotstoneImgData} from './view360config'
import View360LoadingPage from './View360LoadingPage';
import Styles from '../../Css/View360/View360.module.css'
import Switch from "react-switch";
import 'animate.css';
import {OverlayTrigger, Tooltip, Modal} from 'react-bootstrap'
import View360Slider from './View360Slider'
import View360FallbackUI from './View360FallbackUI';

// redux
import {connect} from 'react-redux'
import {updateWholeHotSpotMapObj} from '../../Redux/Reducers/View360Reducer/View360ActionController'


class View360 extends Component {


    constructor(props){
        super(props);

        this.state = {
            images: [],
            imageIndex : 0,
            noOfImg: 0,
            oldx : 0,
            loading: true,
            imgId: '',
            hotSpotsToMap: [],
            dragSpeed: 5,
            hotSpotModal: {
                show: false,
            },
            freshLoad: true,
            toggleHotspotView: false,
            imageNewDimensions : {
                isNewDimensionsUpdated : false,
                isPadByWidth: false,
                newImgWidth: 1,
                newImgHeight: 1,
                newContainerWidth:  1,
                newContainerHeight:  1,
                paddingHalf: 0
            },
            modalList: new Map(),
            errStatus : {
                code: 500, // handle errors
                show: false
            },
            goToSlide: 0, // open this slide on modal,
            lazyLoadImages: false,
            renderHotSpots: false,
            isAnyHotSpotPresent: false,
            isRequestFor3DModel: false,
            isInput360Requested: false
        }

        this.handleHotSpotViewToggle = this.handleHotSpotViewToggle.bind(this);
    }


    componentDidMount = async () => {

        // track window resize, and update NewImageDimensions
        window.addEventListener('resize', this.updateNewImageDimensions);

        if(this.props && this.props.dragSpeed){
            this.setState({
                ...this.state,
                dragSpeed: this.props.dragSpeed
            })
        }

        const {imageCategory, type} = this.getSkuIdAndImageCategory();
        if( imageCategory && imageCategory==='3D_Model'){
            this.setState({...this.state, 'isRequestFor3DModel': true})
        }else if(type && type==='input'){
            this.setState({...this.state, 'isInput360Requested': true})
        }
        await this.fetchImages();

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateNewImageDimensions);
    }

    getSkuIdAndImageCategory = ()=>{
        try {
            const queryParams = new URLSearchParams(window.location.search);
            const skuId = queryParams.get('sku_id');
            const imageCategory = queryParams.get('image_category');
            const skuName = queryParams.get('sku_name');
            const enterpriseId = queryParams.get('enterprise_id');
            let type = queryParams.get('type')
            if(!type) type = 'output' 
            return {skuId,imageCategory,type, skuName, enterpriseId}
        } catch (error) {
            //console.log(error);
        }
    }
    /**
     * Fetch images and hotspots from db
     * @returns 
     */
    fetchImages = async()=>{

        try {
            const {skuId, imageCategory, type, skuName, enterpriseId} = this.getSkuIdAndImageCategory();

            const images=[];

            if((!skuId && (!skuName || !enterpriseId)) || !imageCategory) return;

            const URL = `${process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX}/api/v1/hotspot/get-sku-image-data`;
            const params = {
                'skuId': skuId,
                'imageCategory' : imageCategory,
                'type': type
            }
            if(!skuId){
                params.skuName=skuName
                params.enterpriseId=enterpriseId
            }
            const {skuDetails, skuId: skuIdFromBE} = await centralAPI.handleGetRequest(URL, params);

            if(!skuDetails || !skuDetails.length) throw Error('Fetch req successful, still skuDetails came out as null or empty array');

            const allImageIDs = [];
            skuDetails.forEach(image=>{
                images.push({
                    src: image['output_image_hres_url'],
                    imageId: image['image_id'],
                    imageName: image['image_name']
                });

                allImageIDs.push(image['image_id']);
            });

            let hotSpotMapURL = `${process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX}/api/v1/hotspot/get-hotspots`;
            let mapping = await centralAPI.handleGetRequest(hotSpotMapURL,{
                skuId: skuIdFromBE
            });    
            // let mapping = {
            //     'hotspots' : []
            // }
            if(mapping)
                this.setHotSpotMapObjInStore(mapping,images, type==='input');
        } catch (error) {

            if(error && error.message && error.message.match(/404/gmi)){
                this.setState({...this.state, loading: false, errStatus: {code: 404, show: true}})
            }
        }

        
    };

    /**
     * Create hotspot mapping, if isHidden is false
     * and hotSpotMap
     * @param {*} mapping 
     */
     setHotSpotMapObjInStore = (mapping, images, isInputRequested=false)=>{
        try {
            //console.log(mapping.hotspots);

            const newHotSpotMapObj = new Map();
    
            const newModalList = new Map() // {title, desc, url, closeUpURL, hotSpotId}
            /**
             * imageId use as map key, if isHidden is false
             * 
             * if the hotSpots array contains elements, put them under this imageId,
             * else leave as it is
             * 
             */
            let isAnyHotSpotPresent = false;
            
            mapping.hotspots.forEach((element)=>{
                const {imageId, isHidden, hotSpotArray} = element;
                const newImageHotSpots = new Map();
                //console.log('element',element)
                if(!isHidden){    
                    hotSpotArray.forEach(hotSpotObj=>{
                        // mark 'isAnyHotSpotPresent' true if hot spot present
                        if(isInputRequested){
                            // here we are setting input coordinates as coordinates to let the flow work same as it works for output
                            hotSpotObj['coordinates'] = hotSpotObj['input_coordinates']
                        }
                        isAnyHotSpotPresent = true;
                        newImageHotSpots.set(hotSpotObj.hotSpotId, {...hotSpotObj});
                        // set modal-list, if this id is not there in newModalList
                        if(!newModalList.has(hotSpotObj.hotSpotId)){
                            newModalList.set(hotSpotObj.hotSpotId, {
                                title: hotSpotObj.hotSpotTitle || '',
                                desc: hotSpotObj.hotSpotDesc || '',
                                url: hotSpotObj.hotSpotURL || '',
                                closeUpURL: hotSpotObj.hotSpotCloseUpURL || this.setImageSrcInPlaceOfCloseUpURL(imageId, images)
                            });
                        }
                    });

                }
                newHotSpotMapObj.set(imageId, {isHidden,imageHotSpots:newImageHotSpots});
            });   
          
           
            this.props.updateWholeHotSpotMapObj(newHotSpotMapObj);
            // load the original content and set loading page to false
            this.setState({
                ...this.state,
                images : [...images],
                noOfImg : images.length || 0,
                modalList: newModalList,
                isAnyHotSpotPresent: isAnyHotSpotPresent
            })

            // stop loading after 5 sec
            setTimeout(()=>{
                this.setState({...this.state,loading: false,lazyLoadImages: true})
            },5000)
        } catch (error) {
            //console.log(error);

            this.setState({
                ...this.state,
                loading: false,
                lazyLoadImages: true
            })
        }
    }

    setImageSrcInPlaceOfCloseUpURL = (imageIdToMatch, imagesList)=>{
        let imgSrc = '';
        try {
            
            for(let i=0;i<imagesList.length;i++){
                const {src,imageId} = imagesList[i];

                if(imageIdToMatch===imageId){
                    imgSrc = src;
                    break;
                }
            }

        } catch (error) {
            //console.log(error)
        }

        return imgSrc;
    }

    /**
     * Mouse move handle
     * @param {*} e 
     */
    move = (e)=>{
        try {
            if(!this.state.imageNewDimensions.isNewDimensionsUpdated)
                this.updateNewImageDimensions();

               
               
                let perImgSpeed=Math.floor(this.state.imageNewDimensions.newContainerWidth/(2*this.state.images.length));
                
            this.setState({...this.state, renderHotSpots: !this.state.renderHotSpots, dragSpeed:perImgSpeed})
           
            const pageX = e.pageX ? e.pageX : e.changedTouches[0].pageX; // for touch changes
            let newIndex = null;
            if (pageX <= this.state.oldx-this.state.dragSpeed) {
                let right = ( parseInt(this.state.imageIndex) + 1 ) % parseInt(this.state.noOfImg);
                newIndex = right;
            } else if (pageX >= this.state.oldx+this.state.dragSpeed) {
                let left = (this.state.imageIndex - 1 < 0 )? (this.state.noOfImg-1) : (this.state.imageIndex-1);
                newIndex = left;
            }
            if(newIndex!==null && newIndex!==this.state.imageIndex){
                //console.log({'oldIndex':this.state.imageIndex, 'newIndex':newIndex})
                this.setState({
                    ...this.state,
                    imageIndex : newIndex,
                    oldx : pageX,
                    imgId: this.state.images[newIndex].imageId
                })
            }
        } catch (error) {
            //console.log(error);
        }
    }

    /**
     * Mouse grab
     * @param {*} e 
     */
    handleMouseDown = (e)=>{
        e.preventDefault();
        // close modal if open
        this.setState({...this.state,hotSpotModal:{ show: false}});
        e.target.addEventListener('mousemove', this.move);
    }


    /**
     * Mouse ungrab
     * @param {*} e 
     */
    handleMouseUp = (e)=>{
        e.target.removeEventListener('mousemove', this.move)
    }


    /**
     * Get img container dimensions
     */
    updateNewImageDimensions=()=>{
        try {
            
                const containerRef = document.getElementById('imageActualContainer');
                if(!containerRef) return;
                const containerCoordinates= containerRef.getBoundingClientRect()
                const container = {
                    width: containerCoordinates.width,
                    height: containerCoordinates.height
                }
                const image = {
                    width: containerRef.children[0].naturalWidth,
                    height: containerRef.children[0].naturalHeight
                }
                let ratio_diff = parseFloat(container.height) / parseFloat(image.height) ;
                let newImage = {
                    width: parseFloat(ratio_diff) * image.width,
                    height: parseFloat(ratio_diff) * image.height
                }
                let padding = (container.width - newImage.width )/2;
                if(padding<0){
                    ratio_diff = parseFloat(container.width) / parseFloat(image.width);

                    newImage = {
                        width: ratio_diff * image.width,
                        height: ratio_diff * image.height
                    }
                    padding = (container.height - newImage.height )/2;
                    // console.log({'ratio_diff': ratio_diff,'image':image,'container':container,'newImage': newImage,'padding': padding})
                    this.setState({
                        ...this.state,
                        imageNewDimensions : {
                            isNewDimensionsUpdated : true,
                            isPadByWidth: false,
                            newImgWidth: newImage.width || 1,
                            newImgHeight: newImage.height || 1,
                            newContainerWidth: container.width || 1,
                            newContainerHeight: container.height || 1,
                            paddingHalf: padding
                        }
                    })

                }else{

                    this.setState({
                        ...this.state,
                        imageNewDimensions: {
                            isNewDimensionsUpdated : true,
                            isPadByWidth: true,
                            newImgWidth: newImage.width || 1,
                            newImgHeight: newImage.height || 1,
                            newContainerWidth: container.width || 1,
                            newContainerHeight: container.height || 1,
                            paddingHalf: padding
                        }
                    })
                    // console.log({'ratio_diff': ratio_diff,'image':image,'container':container,'newImage': newImage,'padding': padding})
                }
        } catch (error) {
            //console.log(error)
        }
    }

    calculateLeftAsPerAspect = (leftPercentageFromImageLeft)=>{
        try {
            if(!leftPercentageFromImageLeft) return 50;
            if(!this.state.imageNewDimensions.isNewDimensionsUpdated)
                this.updateNewImageDimensions();
            let newImageDimensions = this.state.imageNewDimensions;
            if(!newImageDimensions.isPadByWidth) return leftPercentageFromImageLeft;
            // convert to pixels
            const leftPixelFromImgLeft = (leftPercentageFromImageLeft * newImageDimensions.newImgWidth )/100;
            const newLeftFromContainer = leftPixelFromImgLeft + newImageDimensions.paddingHalf;
            const newPercentFromContainer =  ( newLeftFromContainer / newImageDimensions.newContainerWidth )*100;
            return newPercentFromContainer
        } catch (error) {
           // console.log(error);
        }
    }

    calculateTopAsPerAspect = (topPercentageFromImageTop)=>{
        try {
            if(!topPercentageFromImageTop) return 50;

            if(!this.state.imageNewDimensions.isNewDimensionsUpdated)
                this.updateNewImageDimensions();
            let newImageDimensions = this.state.imageNewDimensions;
            if(newImageDimensions.isPadByWidth) return topPercentageFromImageTop;
            // convert to pixels
            const topPixelFromImgTop = (topPercentageFromImageTop * newImageDimensions.newImgHeight )/100;
            const newTopFromContainer = topPixelFromImgTop + newImageDimensions.paddingHalf;
            const newPercentFromContainer =  ( newTopFromContainer / newImageDimensions.newContainerHeight )*100;
            return newPercentFromContainer;
        } catch (error) {
            //console.log(error);   
        }
    }

    handleHotSpotClick = async(e)=>{
        try {
            e.stopPropagation(); // don't want touch event to propagate
            if(this.props.hotSpotMapObj && this.props.hotSpotMapObj.size && this.state.imgId.length){
                let hotSpotId = e.target.id;
                let slideIndex = 0;
                let modalListKeys = [...this.state.modalList.keys()];
            
                for(let i=0; i<modalListKeys.length; i++){
                    
                    if(modalListKeys[i]===hotSpotId){
                        slideIndex = i;
                        break;
                    }
                }
                await this.setState({
                    ...this.state,
                    hotSpotModal:{show: true},
                    goToSlide: slideIndex
                })
            }
        } catch (error) {
            //console.log(error)
        }
    }

    /**
     * touch grab
     * @param {*} e 
     */
    handleTouchStarted = (e)=>{
        e.target.addEventListener('touchmove', this.move);
    }
    
    /**
    * touch ungrab
    * @param {*} e 
    */
    touchEnd = (e)=>{
        e.target.removeEventListener('touchmove', this.move)
    }


    /**
     * Hotspot toggle
     * @param {*} e 
     */
    handleHotSpotViewToggle = (e)=>{
        try {
            this.setState({ 
                ...this.state,
                toggleHotspotView : !this.state.toggleHotspotView
            });
        } catch (error) {
            //console.log(error)
        }
    }


    /**
     * @returns left position in pixels
     */
    computeHotSpotTogglePositionLeft = ()=>{
        try {
            // if padding is not by width, return 10px
            const newImageDimensions = this.state.imageNewDimensions;
            if(!newImageDimensions || !newImageDimensions.isPadByWidth) return 10;

            // else add padding + 10 pixels
            return newImageDimensions.paddingHalf + 10;
        } catch (error) {
           // console.log(error);
        }
    }

    /**
     * @returns top position in pixels
     */
     computeHotSpotTogglePositionTop = ()=>{
        try {
            // if padding is by width, return 10px
            const newImageDimensions = this.state.imageNewDimensions;
            if(!newImageDimensions) return 10;

            let hotSpotToggleViewContainer = document.getElementById('hotspot-toggle-view-id');
            let containerHeight = 30;
            if( hotSpotToggleViewContainer){
                containerHeight = hotSpotToggleViewContainer.getBoundingClientRect().height;
            }
            // if padding by width
            if(newImageDimensions.isPadByWidth){
                return newImageDimensions.newImgHeight - containerHeight - 10 ;
            }
            // else add padding + newImageHeight - 10px (from bottom) - height os hotspotcontainer pixels
            return newImageDimensions.paddingHalf + newImageDimensions.newImgHeight - containerHeight - 10 ;
        } catch (error) {
            //console.log(error);
        }
    }

    render() {
        return (
            <div className={Styles['view-360-container']}>
                {
                    this.state.loading ? (
                        <View360LoadingPage />
                    ):(
                        <div className="row justify-content-center align-items-center">
                            {/* <div className="col-11" style={{...customStyle.maxHeight}}> */}
                                <div  className={[Styles['front'],'d-flex','justify-content-center','align-items-center'].join(' ')}>
                                    {
                                        this.state.images.length && this.state.lazyLoadImages ? (
                                            <div className={[Styles['slickListContainer']]} id="imageActualContainer">
                                                <img 
                                                    src={this.state.images[this.state.imageIndex].src} 
                                                    alt={this.state.images[this.state.imageIndex]?.imageName || ''} 
                                                    id={this.state.images[this.state.imageIndex].imageId}
                                                    onMouseDown={this.handleMouseDown} 
                                                    onMouseUp={this.handleMouseUp} 
                                                    onTouchStart={this.handleTouchStarted}
                                                    onTouchEnd={this.handleTouchEnd}
                                                    draggable="false"
                                                />

                                                {
                                                    ( this.props.hotSpotMapObj.get(`${this.state.imgId}`) && this.state.toggleHotspotView ) ? (
                                                        [...this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.keys()].map(hotspotObjKey=>{
                                                            return (
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id="button-tooltip-2">
                                                                                {
                                                                                    this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotTitle
                                                                                }
                                                                            </Tooltip>
                                                                        }
                                                                        key={this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotId}
                                                                    >
                                                                        {({ ref, ...triggerHandler }) => (
                                                                            <div
                                                                                {...triggerHandler}
                                                                                className="d-inline-flex align-items-center"
                                                                                
                                                                            >
                                                                                <img
                                                                                    src={this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotIconSrc}
                                                                                    className={[Styles['slickListContainerItemcentered']]}
                                                                                    onClick={this.handleHotSpotClick}
                                                                                    onTouchStart={this.handleHotSpotClick}
                                                                                    id={this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotId}
                                                                                    alt={this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotTitle}
                                                                                    style={{left:`${this.calculateLeftAsPerAspect(this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.xAxis)}%`, 
                                                                                            top:`${this.calculateTopAsPerAspect(this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.yAxis)}%`,
                                                                                    }}
                                                                                    ref={ref}
                                                                                    draggable="false"
                                                                                />  
                                                                                <span 
                                                                                    className={[Styles['slickListContainerItemcentered-span']]}
                                                                                    style={{left:`${this.calculateLeftAsPerAspect(this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.xAxis)}%`, 
                                                                                            top:`${this.calculateTopAsPerAspect(this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.yAxis)}%`,
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </OverlayTrigger>
                                                            )
                                                        })                                                         
                                                                            
                                                    ):(null)
                                                }
                                                {
                                                    this.state.isAnyHotSpotPresent && this.state.imageNewDimensions.isNewDimensionsUpdated ? (
                                                    <div 
                                                        className={[Styles['hotspot-toggle-view'],'animate__animated','animate__fadeIn'].join(' ')}
                                                        id="hotspot-toggle-view-id"
                                                        style={{left: `${this.computeHotSpotTogglePositionLeft()}px`,
                                                            top: `${this.computeHotSpotTogglePositionTop()}px`
                                                        }}
                                                    >
                                                        <span className={[Styles['dot']]}></span>
                                                        <span>HotSpots</span>
                                                        <Switch 
                                                            onChange={this.handleHotSpotViewToggle} 
                                                            checked={this.state.toggleHotspotView} 
                                                            onHandleColor="#51bd51"
                                                            offHandleColor="#c4c9c4"
                                                        />
                                                    </div>) : null
                                                }

                                            </div>
                                        ) : (null)
                                    }
                                </div>
                            {/* </div> */}

                            {/* HotSpot PopUp Modal Start*/}
                                    <Modal 
                                        show={this.state.hotSpotModal.show} 
                                        onHide={()=>this.setState({...this.state, hotSpotModal:{show: false}})} animation={false}
                                        size="md"
                                        dialogClassName="modal-90w"
                                        centered
                                    >
                                        <Modal.Body>
                                            <View360Slider 
                                                modalList={this.state.modalList} 
                                                hideModal={()=>this.setState({...this.state, hotSpotModal:{show: false}})}
                                                goToSlide={this.state.goToSlide}
                                            />
                                        </Modal.Body>
                                    </Modal>
                            {/* HotSpot PopUp Modal End*/}
                        </div>
                    )
                }

                {
                    this.state.images.length && !this.state.lazyLoadImages ? (
                        this.state.images.map(imgData=>{
                            return (
                                <span  key={imgData.src} style={{display:'none'}}>
                                    <img src={imgData.src} alt="" style={{display:'none'}}/>
                                </span>
                            )
                        })
                    ) : null
                }
                {
                   this.state.errStatus.show ? 
                   <>
                   {
                    this.state.isRequestFor3DModel ? 
                    <div className={[Styles['fallback-ui-container'], Styles['please-wait']].join(' ')}>
                        Your 3d model is being generated, kindly <br/> check back after few minutes
                    </div>
                    : <View360FallbackUI errStatus={this.state.errStatus.code}/>
                   }
                    </> : null
                }
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps)=>{
    //console.log(state.view360Reducer)
    return{
        hotSpotMapObj : state.view360Reducer.hotSpotMapObj,
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        updateWholeHotSpotMapObj: (hotSpotMapObj) => dispatch(updateWholeHotSpotMapObj(hotSpotMapObj)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(View360);